<template>
    <div class="container">
        <section class="brand">
            <div class="welcome">
                <img class="logo" src="@/assets/logo.svg" alt="brand" />
                <p>Beyond the Records. Below the Surface Web.</p>
                <p>There is a lot to Discover.</p>
            </div>
            <div id="bg" :style="{backgroundImage: 'url(' + require('@/assets/auth-bg.svg') + ')'}"></div>
        </section>
        <section class="auth">
            <template>
                <div class="tw-w-full form-cnt tw-min-h-full">
                    <form @submit.prevent="submitForm" class="tw-pr-10">
                        <div class="tw-flex tw-flex-col tw-gap-8 tw-pr-0 tw-pl-8 tw-ml-4">
                            <div>
                                <!-- <Logo1/> -->
                                <img :src="Logo1" class="logo" />
                            </div>
                            <div>
                                <p class="tw-block tw-mb-2 tw-text-black tw-text-2xl tw-font-semibold">Login to your account</p>
                            </div>
                            <div>
                                <div class="tw-mb-8 tw-relative">
                                    <label for="Email" class="tw-block tw-mb-2 tw-text-sm tw-font-noraml tw-text-gray-900 tw-dark:text-white">Email</label>
                                    <div class="tw-flex tw-items-center tw-relative">
                                        <input
                                            type="text"
                                            id="Email"
                                            v-model="formData.email"
                                            class="tw-bg-gray-50 tw-border tw-border-gray-300 tw-gray-900 tw-text-base tw-rounded tw-focus:ring-blue-500 tw-focus:border-blue-500 tw-block tw-w-full tw-px-4 tw-py-2.5 tw-dark:bg-gray-700 tw-dark:border-gray-600 tw-dark:placeholder-gray-400 tw-dark:text-white tw-dark:focus:ring-blue-500 tw-dark:focus:border-blue-500 tw-h-12"
                                            :class="showError && !isEmailValid ? 'errorColor' : 'tw-border-gray-300'"
                                            placeholder="Enter Email"
                                            :disabled="isEmailFilled"
                                            @change="disableError"
                                        />
                                    </div>
                                    <span :class="{hideError: !(showError && !isEmailValid)}" class="tw-text-red-600 tw-text-xs error">Invalid Email</span>
                                </div>
                                <div class="tw-my-8 tw-relative">
                                    <label for="password" class="tw-block tw-mb-2 tw-text-sm tw-font-normal tw-text-gray-900 tw-dark:text-white">Password</label>
                                    <div class="tw-flex tw-items-center tw-relative">
                                        <input
                                            type="password"
                                            ref="passRef"
                                            id="password"
                                            v-model="formData.password"
                                            autocomplete="new-password"
                                            class="tw-bg-gray-50 tw-border tw-border-gray-300 tw-text-gray-900 tw-text-base tw-rounded tw-focus:ring-blue-500 tw-focus:border-blue-500 tw-block tw-w-full tw-px-4 tw-py-2.5 tw-dark:bg-gray-700 tw-dark:border-gray-600 tw-dark:placeholder-gray-400 tw-dark:text-white tw-dark:focus:ring-blue-500 tw-dark:focus:border-blue-500 tw-h-12"
                                            :class="showError && !isPassValid ? 'errorColor' : 'tw-border-gray-300'"
                                            placeholder="Enter Password"
                                            @blur="handleInputBlur"
                                        />
                                        <img :src="closedEye" class="tw-absolute tw-right-4 tw-cursor-pointer" @click="togglePass" v-if="!isPassVisible" />
                                        <img :src="eye" class="tw-absolute tw-right-4 tw-cursor-pointer" @click="togglePass" />
                                    </div>
                                    <span :class="{hideError: !(showError && !isPassValid && formData.password)}" class="tw-text-red-600 tw-text-xs error">Should be a minimum of 8 characters</span>
                                    <div class="tw-text-right" v-if="!isEmailFilled">
                                        <router-link to="/forgot-password" class="tw-text-primary tw-text-right tw-text-xs tw-mt-2 tw-cursor-pointer tw-no-underline forget-pass">Forgot Password?</router-link>
                                    </div>
                                    <!-- <span v-if="$v.formData.password.$dirty && !$v.formData.password.required">Name is required.</span> -->
                                </div>
                            </div>
                            <button class="form-btn tw-bg-blue-500 tw-hover:bg-blue-700 tw-text-white tw-font-bold tw-py-2 tw-px-4 tw-rounded tw-focus:outline-none tw-focus:shadow-outline tw-w-full tw-h-12 tw-cursor-pointer" :class="{btnDisable: !isFormFilled || disabled}" type="submit" :disabled="!isFormFilled || disabled">
                                <nLoader v-if="disabled" class="tw-h-8 tw-w-8"></nLoader>
                                {{ !disabled ? "Continue" : "" }}
                            </button>
                        </div>
                    </form>
                </div>
            </template>
        </section>
    </div>
</template>
<script>
import {Logo1} from "@/plugins/common.js";
import {sendOtpForLogin} from "./services";
import NLoader from "@/components/n-loader";

export default {
    components: {
        NLoader,
    },
    data() {
        return {
            Logo1,
            requestId: null,
            disabled: false,
            formData: {
                email: "",
                password: "",
            },
            showError: false,
            eye: require("@/assets/svg/eye.svg"),
            closedEye: require("@/assets/svg/closeeye.svg"),
            bgimg: require("@/assets/svg/authbg.svg"),
            isEmailFilled: false,
            isPassVisible: false,
        };
    },
    mounted() {
        if (this.$route?.params?.email) {
            this.formData.email = this.$route?.params?.email;
            this.isEmailFilled = true;
        }
    },
    methods: {
        async submitForm() {
            try {
                this.disabled = true;
                this.showError = true;
                if (!this.isEmailValid || !this.isPassValid) return (this.disabled = false);
                const data = await sendOtpForLogin(this.formData);
                if (data.status == true) {
                    this.requestId = data.challenge_metadata;
                    if (data.status_code == 1007) {
                        this.disabled = false;
                        this.$router.push(`/update-password?challenge_metadata=${this.requestId}&user_id=${data.user_id}&user_type=New`);
                        return;
                    } else {
                        this.disabled = false;
                        this.moveToPath(this.requestId);
                        this.$toast.success(data.message || "OTP send successfully!");
                    }
                } else {
                    this.disabled = false;
                    this.$toast.error(data.message || "Something went wrong!");
                }
            } catch (error) {
                this.disabled = false;
                this.$toast.error("Something went wrong!");
            }
        },
        disableError() {
            this.disabled = false;
        },
        togglePass() {
            this.$refs.passRef.type = this.$refs.passRef.type === "text" ? "password" : "text";
            this.isPassVisible = !this.isPassVisible;
        },
        handleInputBlur() {
            this.$refs.passRef.type = "password";
        },
        moveToPath() {
            this.$router.push(`/otp-login?requestId=${this.requestId}`);
        },
        isValidEmail(email) {
            const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
            return emailRegex.test(email);
        },
    },
    computed: {
        isFormFilled() {
            return this.formData?.email && this.formData?.password;
        },
        isEmailValid() {
            return this.isValidEmail(this.formData.email);
        },
        isPassValid() {
            return this.formData?.password.length >= 8;
        },
    },
};
</script>
<style lang="scss">
.container {
    background-color: white;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    height: 100vh;
    width: 100vw;

    .brand {
        height: 100%;
        background-color: var(--brand-color);
        display: grid;
        place-content: center;
        position: relative;

        .welcome {
            display: flex;
            flex-direction: column;
            align-items: center;
            position: relative;
            z-index: 999;

            #logo {
                width: 200px;
                height: 72px;
                margin-bottom: 5rem;
            }

            p {
                font-size: 32px;
                font-family: "Montserrat";
                color: white;
                margin: 0.5rem 2rem;
                font-weight: 200;
            }
        }

        #bg {
            position: absolute;
            height: 100%;
            width: 100%;
            background-repeat: no-repeat;
            background-size: cover;
        }
    }

    .loginImage-cnt {
        width: 50%;
        height: 100vh;
        // overflow: hidden;
        display: flex;
    }
    .form-cnt {
        display: flex;
        flex-direction: column;
        justify-content: center;
        padding: 6%;
        background-color: white;
    }
    .logo {
        width: 200px;
        height: 72px;
    }
    .btnDisable {
        background-color: #ddd;
        color: #858585;
    }
    .rounded {
        border-radius: 10px;
    }
    .form-cnt-div {
        padding: 3rem;
    }
    input {
        font-size: 16px;
        border-radius: 10px;
        border: 1px solid #d8dbe0;
    }
    input:focus {
        outline: 1px solid rgb(59, 130, 246);
    }
    input::placeholder {
        color: #49454f;
    }
    button {
        border-radius: 10px;
        border-width: 0px;
        font-size: 16px;
        background-color: #0d69d5;
        font-weight: 700;
    }
    .forget-pass {
        color: rgb(13, 106, 213);
    }
    * {
        font-family: "Poppins", sans-serif !important;
    }
    .auth {
        overflow-y: scroll;
    }
    form {
        max-width: 36rem;
    }
    .hideError {
        visibility: hidden;
    }
    .error {
        position: absolute;
    }
    .errorColor {
        border: 1px solid red !important;
        outline: none !important;
    }
}
</style>
